import qs from 'qs';
import openLink, { getSuffix } from 'src/libs/open-link';
import { env } from '@byted/ecom-mobile-lib';
import bridge from 'libs/bridge';
import compareVersion from 'utils/compareVersion';
import { getAdInfo } from 'src/components/pay/middlewares/order';
import { getContext } from '@tetris/ad.js';
import { getAdInfoJson } from 'src/libs/ad';
import query from 'libs/query';
import { isAd as isAdPage } from 'utils/ad';
import { getAbTestParams } from 'src/utils/ab';
import { compare } from 'compare-versions';
import { reject } from 'lodash';

const payPagesControl =
    'hide_bar=1&hide_nav_bar=1&hide_back=1&hide_back_close=1&hide_back_button=1&bounce_disable=1&disable_bounce=1&disable_bounces=1&status_bar_color=ffffff&loading_bgcolor=ffffff&status_font_dark=1';
const extraQuery = 'web_title=1&status_bar_color=ffffff&loading_bgcolor=ffffff&status_font_dark=1';
// 标识使用webtitle
export const useWebTitle = 'web_title=1&hide_h5_title=0';

const __test__ = process.env.NODE_ENV === 'development';

const isAd = isAdPage();

export const buynowUrl = (
    id: string,
    comboId: string,
    comboNum: number,
    hideCustomTitleBar: boolean
): Promise<string> => {
    // 需要透传的通参
    const joinExtraQuery = ['page_id', 'activity_id', 'alkey'];

    return new Promise((resolve) => {
        const commonParams = joinExtraQuery.reduce(
            (acc, cur) => acc + (query[cur] ? `&${cur}=${query[cur]}` : ''),
            `id=${id}&combo_num=${comboNum}&combo_id=${comboId}`
        );

        const webUrl = `/views/product/buynow?${commonParams}${isAd ? '&getAdInfoLocal=1' : ''}${
            hideCustomTitleBar ? '&hide_custom_title_bar=1' : ''
        }&${extraQuery}`;

        if (!env.isInToutiao || compare(env.appVersion, '7.9.2', '<')) {
            return resolve(webUrl);
        }

        getAbTestParams('pindao', 'useFlutter', false, { timeout: 2000 })
            .then((res) => {
                if (!res) resolve(webUrl);

                let flutterUrl = `local-flutter://electronic_commercial/submit_order?from=buynow&${commonParams}&${getSuffix()}`;

                getAdInfoJson()
                    .then((res) => {
                        flutterUrl += `&adinfojson=${encodeURIComponent(JSON.stringify(res))}`;
                    })
                    .finally(() => {
                        resolve(
                            `sslocal://dynamicart?url=${encodeURIComponent(
                                flutterUrl
                            )}&fallback=sslocal%3a%2f%2fwebview%3furl%3dhttps%3a%2f%2fhaohuo.jinritemai.com%2fviews%2fproduct%2fbuynow%26hide_bar%3d1%26hide_nav_bar%3d1%26hide_back%3d1%26hide_back_close%3d1%26hide_back_button%3d1%26bounce_disable%3d1%26disable_bounce%3d1%26disable_bounces%3d1%26status_bar_color%3dffffff%26loading_bgcolor%3dffffff%26status_font_dark%3d1`
                        );
                    });
            })
            .catch(() => {
                resolve(webUrl);
            });
    });
};

export const cartUrl = () =>
    `/views/product/cart?hide_nav_bar=1&${extraQuery}&login_source=click_shopping_cart_from_product_page`;

export const detailUrl = ({ id }: { id: string }) => {
    return `/views/product/detail?id=${id}&${extraQuery}`;
};

interface LinkParams {
    id: string;
    extraParams?: string;
    enterFrom?: string;
    authorId?: string;
    secAuthorId?: string;
    options?: any;
    entranceInfo?: string;
    ecomEntranceForm?: string;
    v3EventsAdditions?: string;
}

export const openProductDetail = ({
    id,
    extraParams,
    enterFrom,
    authorId,
    secAuthorId,
    options,
    entranceInfo,
    ecomEntranceForm,
    v3EventsAdditions
}: LinkParams) => {
    const webLink = () =>
        openLink(
            `/views/product/detail?id=${id}&${extraQuery}${extraParams ? '&' + extraParams : ''}`,
            {
                title: '商品详情',
                hideBar: true,
                bounceDisable: true
            },
            options
        );
    // TODO: 订单详情跳转新商详显示网络错误，修复线上详情无法打开
    // 抖音端，version >= 12.0.0 支持新商详 schema
    if (env.isInAweme && compareVersion(env.appVersion, '12.0.0') >= 0) {
        let kol_id = authorId;
        let sec_author_id = secAuthorId;

        // 如果 authorId 取不到，则使用 购物小助手 的 ID
        // 什么情况下会取不到？1.店铺压根没有绑定达人；2.店铺封禁 3.server 调用下游失败
        if (!kol_id || !sec_author_id) {
            kol_id = '99514375927';
            sec_author_id = 'MS4wLjABAAAA2I9NdgAKZrz9e0tLm1csyDMNqLESPDm34TdYYqXe8-I';
        }

        const params = qs.stringify({
            promotion_id: id,
            source_page: enterFrom,
            kol_id,
            request_additions: JSON.stringify({
                sec_author_id,
                enter_from: enterFrom
            }),
            meta_params: JSON.stringify({
                product_type: 1
            })
        });

        return bridge
            .call('openSchema', {
                schema: `sslocal://ec_goods_detail/?promotion_id=${id}&source_page=${enterFrom}&kol_id=${kol_id}
                &request_additions=${encodeURIComponent(
                    JSON.stringify({
                        sec_author_id,
                        enter_from: enterFrom
                    })
                )}
                &meta_params=${encodeURIComponent(
                    JSON.stringify({
                        entrance_info: entranceInfo,
                        product_type: 1
                    })
                )}
                ${
                    v3EventsAdditions
                        ? `&v3_events_additions=${encodeURIComponent(v3EventsAdditions)}`
                        : ''
                }
                ${ecomEntranceForm ? `&ecom_entrance_form=${ecomEntranceForm}` : ''}`
            })
            .catch(() => webLink());
    }

    if (env.isInMobile) {
        return openLink(
            `/views/product/detail?id=${id}${extraParams ? '&' + extraParams : ''}`,
            {
                title: '商品详情',
                bounceDisable: true
            },
            options
        );
    }

    return webLink();
};
